import { useLocaleHead } from '#i18n'

/**
 * 输出 hreflang、html lang/dir 等文档级 SEO / a11y 元数据。
 * Dashboard 页面用 `<DashboardI18nHead />`；default layout 在 setup 中直接调用。
 */
export function useI18nDocumentHead() {
  const i18nHead = useLocaleHead({
    dir: true,
    lang: true,
    seo: true,
    key: 'id',
  })

  useHead({
    htmlAttrs: {
      lang: computed(() => i18nHead.value.htmlAttrs?.lang),
      dir: computed(() => i18nHead.value.htmlAttrs?.dir),
    },
    link: computed(() => i18nHead.value.link ?? []),
    meta: computed(() => i18nHead.value.meta ?? []),
  })
}
